import { z } from 'zod';

export const DatiqGeoSuggestionSchema = z.object({
    id: z.string(),
    name: z.string(),
    country: z.string(),
    countryCode: z.string(),
    region: z.string(),
    regionCode: z.string(),
    city: z.string(),
    zip: z.string(),
    lat: z.number(),
    lng: z.number(),
    population: z.number(),
    timezone: z.string(),
    wiki: z.string(),
});

export interface IDatiqGeoSuggestion {
    displayName: string;
    pointId: number; // NOTE: the results from the API use "placeId", but we alias this field to "pointId" using GraphQL to avoid breaking the interface
    latitude: number;
    longitude: number;
    city?: string;
    stateProv?: string;
    postalCode?: string;
    county?: string;
}

export type IDatiqGeoSuggestionResponse = IDatiqGeoSuggestion[];

export interface IDatiqGeoQuerystringParam {
    searchText: string;
}

export const emptyDatiqGeoSuggestion: IDatiqGeoSuggestion = {
    displayName: '',
    pointId: -1,
    latitude: -1,
    longitude: -1,
};

export const emptyDatiqGeoSuggestionResponse: IDatiqGeoSuggestionResponse = [];
